module.exports = "<ng-transclude></ng-transclude>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/accordionGroup/accordionGroup.html
// module id = 1142
// module chunks = 0